module.exports = __webpack_public_path__ + "static/media/filter-search.195bd73e.gif";